export default __webpack_public_path__ + "static/media/Cutting-Edge Technology.9ed34d7e.png";